"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _GatewayService = _interopRequireDefault(require("../../GatewayService.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var feedback = new _GatewayService["default"]('feedbacktwo');

var setScoreVisibility = function setScoreVisibility(userKey, unitKey, cardstackKey, scoreType, value) {
  var params = {
    userBusinessKey: userKey,
    unitBusinessKey: unitKey,
    cardstackBusinessKey: cardstackKey,
    scoreType: scoreType
  };
  return feedback.post('scoreVisibility', value, {
    params: params,
    headers: {
      'Content-Type': 'application/json'
    }
  });
};

var setAutoScoreVisibility = function setAutoScoreVisibility(userKey, unitKey, cardstackKey, value) {
  var scoreType = 'auto';
  return setScoreVisibility(userKey, unitKey, cardstackKey, scoreType, value);
};

var _default = {
  setAutoScoreVisibility: setAutoScoreVisibility
};
exports["default"] = _default;